<template>
    <div class="container">
        <div class="seach-container" id="yj_demo">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">关键字</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入姓名或公司名"
                            ></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                              <span>创建时间</span>
                            </div>
                            <div class="form-box-item-item">
                                <el-date-picker
                                    v-model="dateRange"
                                    size="small"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">合同类型</span>
                            </div>
                            <div class="form-box-item-item">
                                <el-select  v-model="query.type" clearable size="small" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                        <template v-for="type in typeList"  :key="type.Id">
                            <el-option :label="type.name" :value="type.Id"></el-option>
                        </template>
                              </el-select>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">签约状态</span>
                            </div>
                            <div class="form-box-item-item">
                                <el-select v-model="query.state" size="small" clearable placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                        <el-option label="待签约" value="1"></el-option>
                        <el-option label="已签约" value="2"></el-option>
                        <el-option label="未签约" value="3"></el-option>
                              </el-select>
                            </div>
                        </div>
                    </div>   
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">还款状态</span>
                            </div>
                            <div class="form-box-item-item">
                                <el-select v-model="query.moneystate" size="small" clearable placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                        <el-option label="待划款" value="1"></el-option>
                        <el-option label="已划款" value="2"></el-option>
                        <el-option label="已还款" value="3"></el-option>
                        <el-option label="已逾期" value="4"></el-option>
                              </el-select>
                            </div>
                        </div>
                    </div>   
                     <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  icon="el-icon-delete" size="mini" @click="handleEmpty">清空</el-button>
                               <el-button type="success" size="mini" icon="el-icon-document" @click="toExcel(1)">导出</el-button>
                               <!-- <el-button type="success" size="mini" icon="el-icon-download" style="width: 120px;" @click="toExcel(2)">导出合同</el-button> -->
                            </div>
                    </div>
            </div>
        <el-table
                :data="tableData"
                border
                :max-height="scrollHeight">
            <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                    <template #default="scope">
                        <div v-if="(scope.column.property==='Operation')">
                            <el-button
                                    size="mini"
                                    @click="openDetailDialogShow(scope.row)"
                                    type="primary">
                                详情
                            </el-button>
                             <el-button v-if="scope.row.State==2"
                                    size="mini"
                                    type="warning"
                                    @click="openStatusDialog(scope.row)"
                                    >
                                更新
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="info"
                                    v-if="scope.row.FlowID!==0"
                                    @click="handleView(scope.row)">流程详情
                            </el-button>
                        </div>
                        <div v-else-if="(scope.column.property==='Type')">
                            {{getTypeName(scope.row.Type)}}
                        </div>
                        <div v-else-if="(scope.column.property==='State')">
                            <span v-if="scope.row.State==1">待签约</span>
                            <span v-else-if="scope.row.State==2">已签约</span>
                            <span v-else-if="scope.row.State==3">未签约</span>
                            <span v-else-if="scope.row.State==4">已取消</span>
                        </div>
                         <div v-else-if="(scope.column.property==='MoneyState')">
                           <span v-if="scope.row.MoneyState==1">待划款</span>
                            <span v-else-if="scope.row.MoneyState==2">已划款</span>
                            <span v-else-if="scope.row.MoneyState==3">已还款</span>
                            <span v-else-if="scope.row.MoneyState==4">已逾期</span>
                        </div>
                        <div v-else>
                            {{scope.row[scope.column.property]}}
                        </div>
                    </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div style="float: left;font-size:20px;width: 240px;">总计笔数：{{pageTotal}}</div>
            <div style="float: left;font-size:20px;width: 240px;">总计金额：{{totalMoney}}万元</div>
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
            </el-pagination>
        </div>
        <LoanDetail ref="loanDetail"></LoanDetail>
        <YjDetail ref="yjDetail"></YjDetail>
        <!--查看台账详情，全字段展示-->
        <el-dialog v-model="detailDialogShow" width="1000px" title="合同详情">
            <div class="detail-content">
                <div class="detail-tip-div">
                    <div class="detail-tip-front"></div>
                    <div class="detail-tip-text">基本信息</div>
                </div>
                <table class="detail-table">
                    <tr>
                        <td class="title-td" colspan="1">申请用户</td>
                        <td style="cursor: pointer;color:red" colspan="7" @click="getoCreateReport()">
                            {{detailRow.CompanyName?detailRow.CompanyName:detailRow.UserName}}</td>
                    </tr>
                    
                    <tr>
                        <td class="title-td">合同类型</td>
                        <td style="width:36%">{{getTypeName(detailRow.Type)}}</td>
                        <td class="title-td">金额(万元)</td>
                        <td >{{detailRow.Money}}</td>
                    </tr>
                    <tr>
                        <td class="title-td">用户姓名</td>
                        <td>{{detailRow.UserName}}</td>
                        <td class="title-td">身份证号</td>
                        <td>{{detailRow.IdCard}}</td>
                    </tr>
                    <tr>
                        <td class="title-td">手机号</td>
                        <td>{{detailRow.Phone}}</td>
                        <td class="title-td">营业执照</td>
                        <td>{{detailRow.CompanyCode}}</td>
                    </tr>
                    <tr>
                        <td class="title-td">银行负责人</td>
                        <td>{{detailRow.BankUserName}}</td>
                        <td class="title-td">银行名称</td>
                        <td>{{detailRow.BankName}}</td>
                    </tr>
                </table>
                <div class="detail-tip-div">
                    <div class="detail-tip-front"></div>
                    <div class="detail-tip-text">签约情况</div>
                </div>
                <table class="detail-table">
                    <tr>
                        <td class="title-td">状态</td>
                        <td style="width:36%">{{states[detailRow.State-1]}}</td>
                        <td class="title-td">创建时间</td>
                        <td style="width:36%">{{detailRow.CreateTime}}</td>
                    </tr> <tr>
                        <td class="title-td">银行签约时间</td>
                        <td >{{detailRow.BankSignTime}}</td>
                        <td class="title-td">完成时间</td>
                        <td>{{detailRow.EndTime}}</td>
                    </tr> <tr>
                        <td class="title-td">操作</td>
                        <td colspan="7" v-if="detailRow.State==1"><div   style="cursor: pointer;color:red;" @click="handlePreView(detailRow)">预览</div></td>
                    <td colspan="7" v-else><div style="cursor: pointer;color:red;float:left;margin-left: 200px;" @click="handlePreView(detailRow)">预览</div>
                            <div style="cursor: pointer;color:red;float:right;margin-right: 200px;" v-if="detailRow.State>1" @click="handlePreView(detailRow,2)">下载</div></td>
                        </tr>
                </table>
                 <div class="detail-tip-div">
                    <div class="detail-tip-front"></div>
                    <div class="detail-tip-text">还款情况</div>
                </div>
                <table class="detail-table">
                    <tr>
                        <td class="title-td">状态</td>
                        <td style="width:36%">{{moneystates[detailRow.State-1]}}</td>
                        <td class="title-td">还款日期</td>
                        <td style="width:36%">{{detailRow.ReturnDate}}</td>
                    </tr>
                    <tr>
                        <td class="title-td">补充资料</td>
                        <td colspan="7" >
                            <template v-for="(item,i) in detailRow.FileList" :key="i">
                                <div style="float:left;margin-left:20px;cursor: pointer;color:blueviolet;"
                                @click="handleFileView(item)">{{ item.name }}</div>
                            </template>
                           
                        </td>
                    </tr>
                </table>
            </div>
        </el-dialog>
                <!--变更状态-->
        <el-dialog v-model="statusDialogShow" width="30%" title="更新">
            <el-form class="fileup">
                <el-form-item label="还款状态" >
                    <el-select v-model="changeStatus" placeholder="请选择">
                        <el-option label="待划款" value="1"></el-option>
                        <el-option label="已划款" value="2"></el-option>
                        <el-option label="已还款" value="3"></el-option>
                        <el-option label="已逾期" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="还款时间">
                    <el-date-picker
                            v-model="changeEndTime"
                            size="small"
                            type="date"
                            placeholder="选择还款时间">
                    </el-date-picker>
                </el-form-item>
                 <el-form-item label="补充资料" >
                                        <el-upload
                                        accept=".doc,.docx,.xlsx,.xls,.pdf"
                                        class="avatar-uploader"
                                        :on-exceed="handleExceed"
                                        :on-preview="handleFileView"
                                        :before-remove="handleFileRemove_FJ"
                                        :before-upload="beforeAvatarFileUpload"
                                        :http-request="uploadFileFile_FJ"
                                         :limit="9"
                                        :file-list="fileList">
                                        <div  class="yj_upload__tip">点击上传</div>
                                    </el-upload>
                </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="statusDialogShow = false">取消</el-button>
                <el-button type="primary" @click="changeStatusSubmit">确定</el-button>
              </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import indexJs from "./index.js";
    import Template from "../Template";

    export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);
</style>